import React from "react";
export default class SVG extends React.Component {
  render() {
    return <svg width="30" height="30" viewBox="0 0 30 30" xmlns="http://www.w3.org/2000/svg" {...this.props}><path d="M16.024 30H1.656A1.656 1.656 0 0 1 0 28.344V1.656C0 .74.741 0 1.656 0h26.688C29.26 0 30 .741 30 1.656v26.688C30 29.26 29.259 30 28.344 30H20.7V18.382h3.9l.583-4.527H20.7v-2.89c0-1.312.364-2.205 2.243-2.205l2.398-.001v-4.05c-.415-.055-1.838-.178-3.494-.178-3.456 0-5.823 2.11-5.823 5.985v3.339h-3.91v4.527h3.91V30z" fill="#B6C1CD" fillRule="evenodd" /></svg>;
  }

}


// WEBPACK FOOTER //
// ./src/static/images/sources/grey-facebook.svg